export const validateAfterChangeImageField = async (form, fieldName, value) => {
    await form.validateForm({...form.values, [fieldName]: value})
    form.setFieldTouched(fieldName, true)
}
